export default __webpack_public_path__ + "static/media/bancolombiaG.932d3092.png";